import { Button, makeStyles, mergeClasses } from "@fluentui/react-components";
import { $black, $sky60, $white } from "../../../cssjs/colors";

export interface IDateTimeFilterActionsProps {
  onResetHandler: (_event: React.MouseEvent<HTMLButtonElement>) => void;
  onDefaultHandler: (_event: React.MouseEvent<HTMLButtonElement>) => void;
  onApplyHandler: (_event: React.MouseEvent<HTMLButtonElement>) => void;
}

export default function HideUnhideActions(props: IDateTimeFilterActionsProps) {
  const classes = useStyles();

  return (
    <footer className="pt-sm-4 amd-container-vcenter jc-spacebtwn">
      <Button
        className={mergeClasses(classes.resetButton, "mr-1")}
        onClick={props.onResetHandler}
        size="small"
      >
        Reset
      </Button>
      <div>
        <Button
          className={mergeClasses(classes.applyFilterButton, "mr-1")}
          onClick={props.onApplyHandler}
          size="small"
        >
          Apply filter
        </Button>
      </div>
    </footer>
  );
}

const useStyles = makeStyles({
  resetButton: {
    border: `1px solid ${$black}`,
    borderRadius: "3px",
    padding: "5px",
    fontWeight: "600",
    fontSize: "13px",
    ":hover": {
      backgroundColor: $sky60,
      color: $white,
    },
  },
  setasdefaultButton: {
    color: $sky60,
    padding: "5px 10px",
    borderRadius: "3px",
    border: `1px solid ${$sky60}`,
    fontWeight: "600",
    fontSize: "13px",
    ":hover": {
      backgroundColor: $sky60,
      color: $white,
    },
  },
  applyFilterButton: {
    color: $sky60,
    borderRadius: "3px",
    fontWeight: "600",
    fontSize: "13px",
    border: `1px solid ${$sky60}`,
    padding: "5px 18px",
    ":hover": {
      backgroundColor: $sky60,
      color: $white,
    },
  },
});
